const Footer = () => {
    return (
        <div class="fixed bottom-0 left-0 w-full bg-black text-white h-10 p-2 text-xs">
          Copyright © 2025 Shruti Anantwar
        </div>
    );
  };

export default Footer;